import store from "../store/store";
import { SessionHelper } from "./sessionHelper";
// helper used when the user logs in
// or if the page is refreshed or user switches views from euro to asian
export class DarkModeHelper {
  static checkDarkModeStatus() {
    const { sessionModel } = store.getState();
    // get darkmode status in redux store
    const darkMode = sessionModel.darkMode;
    // check localStorage for darkMode status
    const darkModeLocalStorage = SessionHelper.getDarkModeStatus();
    // if darkMode status in store is false
    // and locaStorage darkMode status is true
    // set darkMode status in store to true
    if (!darkMode && darkModeLocalStorage === "true") {
      store.dispatch.sessionModel.enableDarkMode();
    }
  }
}
